<template>
<modal name="medley-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeMedleyDialog"
      icon="el-icon-circle-close-outline"
      style="font-size: 2rem;"
      type="text"></el-button>
  </div>
  <div class="setting" v-if="permissionType == 1">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 140%;">ダウンロードが完了しました！</p>
      <p style="font-size: 140%;">選考と合わせて、<br>好条件の求人が多数掲載されている<br>ジョブメドレーへの登録もしておきましょう。</p>
      <br>
      <p style="font-size: 140%;">業界最大級の求人数から、自分のペースで職探しが可能。理想の職場がきっと見つかります。</p>
      <p style="font-size: 140%;color:red;">サービスご利用者満足度96%！</p>
      <br/>
      <p style="font-size: 140%;">登録すると、事業所から直接スカウト<br>を受け取ることも可能に。</p>
      <p style="font-size: 140%;">今すぐ60秒で簡単無料登録！</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/medley_yagish_logo.png" style="width:100%" >
        </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSendedMedley == false"
        style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-medley-consult');">無料登録する</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isSendedMedley == true"
        style="background-color:#0F9934;border-color:#0F9934;"
          @click="closeMedleyDialog();">送信しました</el-button>
      </div>
      <br/>
    </div>
  </div>
  <div class="setting" v-else-if="permissionType == 2">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
      <p style="font-size: 140%;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/jigen_medley_yagish_logo.png" style="width:100%" >
        </p>
      </div>
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link>
        <br/>
        アルバイトEXの<a href="https://arubaito-ex.jp/terms" target="_blank">利用規約</a>、<a href="https://arubaito-ex.jp/privacy" target="_blank">個人情報保護方針</a>
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;">遷移先のサイトで働きたい</p>
      <p style="font-size: 140%;">アルバイトを探そう！</p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >規約に同意して求人受取や<br>会員登録を希望する
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
      <p style="font-size: 140%;"> 
        <el-checkbox v-model="isAgree" style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して求人受取や<br>会員登録を希望する</el-checkbox>
      </p>
      <br/>
    </div>
    <div class="text-center">
      <el-button id="send-adtop-pdf" type="success" v-if="isSendedJigen == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
        @click="$eventHub.$emit('send-jigen-consult');">普通のアルバイトを希望</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isSendedJigen == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeMedleyDialog();">送信しました</el-button><br>
      <p style="font-size: 140%;">⬇︎看護師、歯科、介護、保育、リハビリ、<br>ヘルスケアなどの専門職</p>
      <el-button id="send-adtop-pdf" type="success"  v-if="isSendedMedley == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
        @click="$eventHub.$emit('send-medley-consult');">専門職のアルバイトを希望</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isSendedMedley == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeMedleyDialog();">送信しました</el-button>
      <br/>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <br/>
      <br/>
      <p style="font-size: 140%;">退職で困っている人は無料で相談に乗るよ！</p>
      <p style="font-size: 140%;">退職関係なら法律にも詳しいよ！</p>
    </div>
    <div class="text-center">
      <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
      onClick="window.open('https://bit.ly/3uT6SV6', '_blank');" ><span>無料で質問する</span></button>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
      </p>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
      </div>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
      </p>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
      </div>
    </div>
  </div>
  <div class="setting" v-else-if="permissionType == 3" >
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
      <p style="font-size: 140%;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/medley_adtop_yagish_logo.png" style="width:90%" >
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">ご同意いただいた方には追って連絡がいき</p>
        <p style="font-size: 140%;">ますので、ご確認お願いいたします！</p>
      </div>
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link>
        <br/>
        アルバイトEXの<a href="https://arubaito-ex.jp/terms" target="_blank">利用規約</a>、<a href="https://arubaito-ex.jp/privacy" target="_blank">個人情報保護方針</a>
        <br/>
        ㈱アド・トップの<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報保護方針</a>
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >規約に同意して無料相談や<br>求人受取、会員登録を希望する
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
      <p style="font-size: 140%;"> 
        <el-checkbox v-model="isAgree" style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して無料相談や<br>求人受取、会員登録を希望する</el-checkbox>
      </p>
      <br/>
    </div>
    <div class="text-center">
      <el-button id="send-adtop-pdf" type="success" v-if="isSendedAdtop == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 120%;" 
        @click="$eventHub.$emit('send-adtop-consult');">正社員希望</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isSendedAdtop == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeMedleyDialog();">送信しました</el-button>
      <p style="font-size: 140%;">⬇︎看護師、歯科、介護、保育、リハビリ、<br>ヘルスケアなどの専門職</p>
      <el-button id="send-adtop-pdf" type="success"  v-if="isSendedMedley == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
        @click="$eventHub.$emit('send-medley-consult');">専門職のアルバイトを希望</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isSendedMedley == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeMedleyDialog();">送信しました</el-button>
    </div>
      <br/>
    <div class="text-center">
      <el-button id="send-adtop-pdf" type="success" v-if="isSendedJigen == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 120%;"
        @click="$eventHub.$emit('send-jigen-consult');">時短やアルバイト希望</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isSendedJigen == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeMedleyDialog();">送信しました</el-button>
      <br/>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;">退職で困っている人は無料で相談に乗るよ！</p>
      <p style="font-size: 140%;">退職関係なら法律にも詳しいよ！</p>
    </div>
    <div class="text-center">
      <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
      onClick="window.open('https://bit.ly/3uT6SV6', '_blank');" ><span>無料で質問する</span></button>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
      </p>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
      </div>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
      </p>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
      </div>
    </div>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isSendedJigen:false,
      isSendedMedley:false,
      isSendedAdtop:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:true,
      medleyID:1,
      medleyPCLnks: {
        1:'https://job-medley.com/lp/hh/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=hh_yagish',
        2:'https://job-medley.com/lp/cw/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=cw_yagish',
        3:'https://job-medley.com/lp/apo/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=apo_yagish',
        4:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        5:'https://job-medley.com/lp/dh/18021/pc/?utm_source=yagish&utm_medium=cpa&utm_campaign=dh_yagish',
        6:'https://job-medley.com/lp/da/18021/pc/?utm_source=yagish&utm_medium=cpa&utm_campaign=da_yagish',
        7:'https://job-medley.com/lp/ans/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=ans_yagish',
        8:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        9:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        10:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish'
      },
      medleySPLnks: {
        1:'https://job-medley.com/lp/hh/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=hh_yagish',
        2:'https://job-medley.com/lp/cw/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=cw_yagish',
        3:'https://job-medley.com/lp/apo/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=apo_yagish',
        4:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        5:'https://job-medley.com/lp/dh/18021/sp/?utm_source=yagish&utm_medium=cpa&utm_campaign=dh_yagish',
        6:'https://job-medley.com/lp/da/18021/sp/?utm_source=yagish&utm_medium=cpa&utm_campaign=da_yagish',
        7:'https://job-medley.com/lp/ans/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=ans_yagish',
        8:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        9:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        10:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish'
      }
    }
  },
  created : function(){
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openMedleyDialog: function (id, html, medleyID) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.medleyID = medleyID
      this.$modal.show('medley-dialog')
      this.clearLocalStorageConfirmVisible = false
      if (this.formatid == 'rerekisho_part_time'
        || this.formatid == "rirekisho_part_time2") {
        this.permissionType = 2
      } else {
        this.permissionType = 3
      }

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'medley_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', '')
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })
    },
    closeMedleyDialog: function () {
      this.$modal.hide('medley-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendAdtopConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'medley_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('reqflg', '2')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.adtopPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSendedAdtop = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたに電話・メールでご連絡することがあります！`,
            type: 'error'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendMedleyConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (this.$deviceLib.isMobileDevice == 'SP') {
        window.open(this.medleySPLnks[this.medleyID], '_blank')
      } else {
        window.open(this.medleyPCLnks[this.medleyID], '_blank')
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'medley_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendLinkMedley, formData, {timeout: 60000})
        .then(function (response) {
          app.isSendedMedley = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendJigenConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const jigen_url = 'https://arubaito-ex.jp/search?kw=&form_type=header_search&ref_code=oem_register_yagish_link&utm_source=register_yagish_link&utm_medium=oem'
      window.open(jigen_url, '_blank')
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'medley_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendJigen, formData, {timeout: 60000})
        .then(function (response) {
          app.isSendedJigen = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-adtop-consult', this.sendAdtopConsult)
    this.$eventHub.$on('send-jigen-consult', this.sendJigenConsult)
    this.$eventHub.$on('send-medley-consult', this.sendMedleyConsult)
    this.$eventHub.$on('open-medley-dialog', this.openMedleyDialog)
    this.$eventHub.$on('popstate', this.closeMedleyDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-adtop-consult', this.sendAdtopConsult)
    this.$eventHub.$off('send-jigen-consult', this.sendJigenConsult)
    this.$eventHub.$off('send-medley-consult', this.sendMedleyConsult)
    this.$eventHub.$off('open-medley-dialog', this.openMedleyDialog)
    this.$eventHub.$off('popstate', this.closeMedleyDialog)
  }
}
</script>
